<template>
    <Head :title="t('setMetaData.teaser:headlines').join(' ')" />

    <div class="mx-auto max-w-3xl pb-8" style="min-height: 50vh">
        <div class="px-4 sm:px-10 sm:text-center max-w-6xl md:mx-auto lg:text-left">
            <div>
                <Teaser :headlines="t('setMetaData.teaser:headlines')" :subline="t('setMetaData.teaser:subline')"></Teaser>
            </div>
        </div>
        <div class="mt-8">
            <div class="bg-white sm:w-full max-w-3xl sm:mx-auto sm:overflow-hidden">
                <SetMetadataBox ref="metaDataBox" :nft="nft" :countries="countries" :industries="industries" :employees="employees" :legalForms="legalForms" :specialties="specialties"></SetMetadataBox>
                <div class="p-5 text-right">
                    <button type="button" @click="submit()" class="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">{{ t('setMetaData.body:buttonLabel') }}</button>
                </div>
            </div>
        </div>
        <Steps :step="2"></Steps>
    </div>

</template>

<script setup>
import Steps from "../../../Components/Steps";
import SetMetadataBox from "../../../Components/SetMetadataBox";
import {Head} from '@inertiajs/inertia-vue3'
import translate from "../../../../lang";
import Teaser from "../../../Components/Common/Teaser";
import {ref} from "vue";


const props = defineProps({
        nft: Object,
        countries: Object,
        industries: Object,
        employees: Object,
        legalForms: Object,
        specialties: Object,
    });
const t = translate('upload-' + props.nft.metaDataType);
const metaDataBox = ref(null);
function submit() {
    let url = route('loc_upload_meta_save', {nft: props.nft.id, metaDataType: props.nft.metaDataTypePath, verify: false});
    metaDataBox.value.form.post(url);
}
</script>
